export async function getShopName(): Promise<string | undefined> {
  const resp = await fetch("/api/store/name/");

  if (resp.status >= 400) return undefined;

  return await resp.text();
}

export async function getStoreData(): Promise<StoreData | undefined> {
  const locationResp = await fetch("/api/location/");

  if (locationResp.status >= 400) return undefined;

  const location = await locationResp.text();

  const storeNameResp = await fetch("/api/store/name/");

  if (storeNameResp.status >= 400) return undefined;

  return {
    alpha2: location,
    shop_name: await storeNameResp.text(),
  } as StoreData;
}
export type StoreData = {
  shop_name: string;
  alpha2: string;
  hasPostal: boolean;
};
